import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RicercaPraticheService } from 'src/app/services/ricerca-pratiche.service';


@Component({
  selector: 'app-assegnazione-istruttore-modal',
  templateUrl: './assegnazione-istruttore-modal.component.html',
  styleUrls: ['./assegnazione-istruttore-modal.component.scss']
})
export class AssegnazioneIstruttoreModalComponent implements OnInit {

  public defaultSelectValue: any = null;
  public buttonLabel: string = 'APPLICATION.BACK_OFFICE.RICERCA_PRATICA.MODAL.BUTTONS.SALVA';
  public form: FormGroup = this.formBuilder.group({
    emailBody: [null, [Validators.required, Validators.maxLength(2000)]],
    mail: [null],
    istruttoreAssegn: [null, [Validators.required]],
    giorni: [null]
  });
  public showExtraData = false;

  public date: Date = new Date();
  public istruttori: Array<any> = [];
  public selected = null;

  ngOnInit() {
    if (this.data.params && this.data.params.body !== undefined && this.data.params.body !== null) {
      this.form.get('emailBody').patchValue(this.data.params.body);
    }
    if (this.data.buttonLabel) this.buttonLabel = this.data.buttonLabel;

    this.ricercaPratiche.getIstruttoriByIdIstituto(this.data.idIstitutoGaranzia).toPromise().then((istruttori: { id: number, nome: string, cognome: string }[]) => {
      this.istruttori = istruttori.map(istruttore => ({ id: istruttore.id, descrizione: `${istruttore.nome} ${istruttore.cognome}` }));
    });
  }

  constructor(
    private readonly translateService: TranslateService,
    private ricercaPratiche: RicercaPraticheService,
    public dialogRef: MatDialogRef<AssegnazioneIstruttoreModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { idIstitutoGaranzia: number, header: string, buttonLabel?: string, text?: string, modalParam?: any, params?: { body: string, mail?: string }, config: 'plain' | 'extended' },
    private formBuilder: FormBuilder
  ) {
    if (data.text)
      this.form.get('emailBody').patchValue(translateService.instant(data.text));
    setInterval(() => {
      this.date = new Date();
    }, 60000);
  }

  public changeSelection(event: any) {
    console.log(this.form.value);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getOutPutData() {
    if (this.form.valid)
      this.dialogRef.close(this.form.value);
    else
      this.form.get('istruttoreAssegn').setErrors({custom: 'APPLICATION.FRONT_OFFICE.ERRORI.RICHIESTO'});
    this.form.get('istruttoreAssegn').updateValueAndValidity();
  }

}
